import { createSlice } from "@reduxjs/toolkit";

export const searchSlice = createSlice({
  name: "search",
  initialState: {
    city: { id: "", name: "" },
    // { cityId, days } — opening hours the selected city can serve, keyed by
    // "Mon".."Sun". Carries its own cityId so a consumer can prove the hours
    // belong to the city it is looking at; effects in one commit all read the
    // same render snapshot, so a bare object gets applied to the wrong city
    // during a switch. null = unknown, read as "no restriction", never "closed".
    cityTimings: null,
    duration: { id: "", value: "", title: "" },
    searchType: "",
    startDateTime: {
      date: "",
      time: "",
    },
    endDateTime: {
      date: "",
      time: "",
    },
    searchVehicles: [],
    vehicleType: [
      "bike",
      "motorbike",
      "electric scooter",
      "electric bike",
      "scooter",
      "car",
    ],
    todayTimeStamp: "",
    mobileSearch: false,
    emptyCartData: false,
    tempStartDateTime: "",
    tempEndDateTime: "",
    tempCityId: "",
    searchAreas: [],
    selectedAreas: [],
    searchBrands: [],
    selectedBrands: [],
    searchFuelTypes: [],
    selectedFuelTypes: [],
    searchTransmissions: [],
    selectedTransmissions: [],
    sortBy: "",
    isSearching: true,
  },

  reducers: {
    setCityname: (state, action) => {
      state.city.id = action.payload.id;
      state.city.name = action.payload.name;
    },
    setDuration: (state, action) => {
      state.duration.id = action.payload.id;
      state.duration.value = action.payload.value;
      state.duration.title = action.payload.title;
    },
    getStartDate: (state, action) => {
      state.startDateTime.date = action.payload.date || state.startDateTime.date;
      state.startDateTime.time = action.payload.time || state.startDateTime.time;
    },
    getEndDate: (state, action) => {
      state.endDateTime.date = action.payload.date || state.endDateTime.date;
      state.endDateTime.time = action.payload.time || state.endDateTime.time;
    },
    
    getAllVehicles: (state, action) => {
      state.searchVehicles = action.payload;
    },
    getVehicleTypes: (state, action) => {
      state.vehicleType = action.payload;
    },
    setTodayTimeStamp: (state, action) => {
      state.todayTimeStamp = action.payload;
    },
    getClearState: (state, action) => {
      state.city = { id: "", name: "" };
      state.startDateTime = {
        date: "",
        time: "",
      };
      state.duration = { id: "", value: "" };
      state.endDateTime = {
        date: "",
        time: "",
      };
      state.searchVehicles = [];
      state.vehicleType = [
        "bike",
        "motorbike",
        "electric scooter",
        "electric bike",
        "scooter",
        "car",
      ];
      state.searchAreas = [];
      state.selectedAreas = [];
      state.searchBrands = [];
      state.selectedBrands = [];
      state.searchFuelTypes = [];
      state.selectedFuelTypes = [];
      state.searchTransmissions = [];
      state.selectedTransmissions = [];
      state.sortBy = "";
    },
    getMobileMenuToggle: (state, action) => {
      state.mobileSearch = action.payload;
    },
    setEmptyCartData: (state, action) => {
      state.emptyCartData = action.payload;
    },
    setSearchType: (state, action) => {
      state.searchType = action.payload;
    },
    getTempDateTime: (state, action) => {
      state.tempStartDateTime = action.payload.sDateTime;
      state.tempEndDateTime = action.payload.eDateTime;
      state.tempCityId = action.payload.tCityId;
    },
    setIsSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    setSearchAreas: (state, action) => {
      state.searchAreas = action.payload;
    },
    setSelectedAreas: (state, action) => {
      state.selectedAreas = action.payload;
    },
    toggleSelectedArea: (state, action) => {
      const areaId = action.payload;
      if (state.selectedAreas.includes(areaId)) {
        state.selectedAreas = state.selectedAreas.filter(
          (id) => id !== areaId
        );
      } else {
        state.selectedAreas = [...state.selectedAreas, areaId];
      }
    },
    setSearchBrands: (state, action) => {
      state.searchBrands = action.payload;
    },
    setSelectedBrands: (state, action) => {
      state.selectedBrands = action.payload;
    },
    setSearchFuelTypes: (state, action) => {
      state.searchFuelTypes = action.payload;
    },
    setSelectedFuelTypes: (state, action) => {
      state.selectedFuelTypes = action.payload;
    },
    setSearchTransmissions: (state, action) => {
      state.searchTransmissions = action.payload;
    },
    setSelectedTransmissions: (state, action) => {
      state.selectedTransmissions = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setCityTimings: (state, action) => {
      state.cityTimings = action.payload ?? null;
    },
  },
});

export const {
  setCityname,
  setCityTimings,
  setDuration,
  getStartDate,
  getEndDate,
  getAllVehicles,
  getVehicleTypes,
  setTodayTimeStamp,
  getClearState,
  getMobileMenuToggle,
  setEmptyCartData,
  getTempDateTime,
  setSearchType,
  setIsSearching,
  setSearchAreas,
  setSelectedAreas,
  toggleSelectedArea,
  setSearchBrands,
  setSelectedBrands,
  setSearchFuelTypes,
  setSelectedFuelTypes,
  setSearchTransmissions,
  setSelectedTransmissions,
  setSortBy,
} = searchSlice.actions;

export default searchSlice.reducer;
